import { skipToken, useMutation, useQuery } from "@tanstack/react-query"
import {
  editCaseNote,
  getCaseChannels,
  getCases,
  getCaseStatusChangeReasons,
  getCaseStatuses,
  getCaseTypes,
} from "./cases"
import { casesKeys } from "./queryKeys"
import type { ICaseSearchParams } from "./types"
import {
  getUniqueValueLabels,
  serializeDataToValueLabel,
} from "@utils/formatters"

export const useEditCaseNoteMutation = () => {
  return useMutation({
    mutationFn: editCaseNote,
  })
}

export const useGetCasesQuery = (
  params: ICaseSearchParams,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: casesKeys.list(JSON.stringify(params)),
    queryFn: isEnabled
      ? ({ signal }) => getCases({ params, signal })
      : skipToken,
  })
}

export const useGetCaseTypesQuery = () => {
  return useQuery({
    queryKey: casesKeys.caseTypes(),
    queryFn: getCaseTypes,
    select: (data) =>
      getUniqueValueLabels(
        serializeDataToValueLabel(data, "case_type_description"),
      ),
  })
}

export const useGetCaseTypeCategoriesQuery = () => {
  return useQuery({
    queryKey: casesKeys.caseTypes(),
    queryFn: getCaseTypes,
    select: (data) =>
      getUniqueValueLabels(serializeDataToValueLabel(data, "category_name")),
  })
}

export const useGetCaseChannelsQuery = () => {
  return useQuery({
    queryKey: casesKeys.caseChannels(),
    queryFn: getCaseChannels,
    select: (data) => serializeDataToValueLabel(data, "case_channel_name"),
  })
}
export const useGetCaseStatusesQuery = () => {
  return useQuery({
    queryKey: casesKeys.caseStatuses(),
    queryFn: getCaseStatuses,
    select: (data) => serializeDataToValueLabel(data, "case_status_name"),
  })
}

export const useGetCaseStatusChangeReasonsQuery = () => {
  return useQuery({
    queryKey: casesKeys.caseStatusChangeReasons(),
    queryFn: getCaseStatusChangeReasons,
    select: (data) =>
      serializeDataToValueLabel(data, "case_status_change_reason_desc"),
  })
}
